import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        //Navbar
        dashboard: 'Dashboard',
        language: 'Language',
        logout: 'Logout',

        //Home
        search: 'Search',
        location: 'Location',
        startDate: 'Start Date',
        endDate: 'End Date',
        startTime: 'Start Time',
        endTime: 'End Time',
        price: 'Price',
        courses: 'Courses',

        //Profile
        name: 'Name',
        email: 'Email',
        phno: 'Phone number',
        address: 'Address',
        pincode: 'Pincode',
        enterPassword: 'Enter new password:',
        password: 'password',
        repeatPassword: 'Repeat Password',
        certNo: 'Certificate No', // -------------------New
        contactPerson: 'Contact',
        contactNo: 'Contact Number',
        createdAt: "Created date",
        edit: 'edit',
        delete: 'delete',
        addNewLocation: 'Add new location',
        locations: 'Locations',
        submit: 'submit',
        resetPassword: 'Reset Password',

        home: {
            active: 'En cours',
            ended: 'Éffectué',
            completed: 'Terminé',
            internshipOngoing: 'Stages en cours',
            search: 'Rechercher',
            addNewClass: 'Créer un nouveau stage',
            viewParticipants: 'Voir les inscrits',
            completeInternship: 'Terminer le stage',
            completedInternships: 'Stages terminés',
            internshipToEnd: 'Stage à terminer',
            confirmCompletion: 'Terminer maintenant',
            studentMovementConfirmation: 'Êtes-vous sure de modifier le stage pour cet élève ?',
            generateCertificate: 'Générer les attestations',
            generateCertificateConfirm: 'Voulez-vous générer l\'attestation pour cet élève ?',
            location: 'Adresse',
            customerMovementSuccess: 'Le stagiaire à été envoyé vers le stage sélectionner',
            participants: 'Participants',
            createInternship: {
                startingDate: 'Date de début',
                endingDate: 'Date de fin',
                startingTime: 'Heure de début',
                endingTime: 'Heure de fin',
                selectBAFM: 'Sélectionner le BAFM',
                selectPsychologist: 'Sélectionner le psychologue',
                selectLocation: 'Sélectionner l\'adresse',
                maxParticipants: 'Nombre maximum de participant',
                price: 'Prix visible par le client',
            }
        },

        trainer: {
            trainer: 'trainer',
            addNewTrainer: 'Ajouter un nouveau formateur',
            viewSchedule: 'Voir le calendrier',
            editTrainer: 'Edit Trainer',
            blockTrainer: 'Unblock Trainer',
            unblockTrainer: 'Entraîneur de blocs',
            firstName: 'First name',
            lastName: 'Last name',
            gender: 'Gender',
            telephoneNo: 'Telephone Number',
            address: 'Adress',
            emailVerified: 'Email Verified',
            actions: 'Actions',

        },

        //Login
        close: 'Close',
        login: {
            email: 'Email',
            password: 'Password',
            loginBtn: 'Login',
            type: 'Centre de formation'
        },
        connexion: {
            email: 'Email',
            password: 'password',
            type: 'Training center connexion'
        }
    },
    fr: {
        //Navbar
        dashboard: 'Tableau de bord',
        language: 'Langue',
        logout: 'Déconnexion',

        //Home
        search: 'Rechercher',
        location: 'Lieu',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        startTime: 'Heure de début',
        endTime: 'Heure de fin',
        price: 'Prix',
        courses: 'Stages',

        //Profile
        name: 'Nom',
        email: 'Email',
        phno: 'Téléphone',
        address: 'Adresse',
        pincode: 'Code postal',
        enterPassword: 'Entrez un nouveau mot de passe:',
        password: 'Mot de passe',
        resetPassword: 'Changer le mot de passe',
        certNo: 'Numéro de certificat', // ------------------------New
        contactPerson: 'Contact',
        contactNo: 'Numéro de contact',
        createdAt: "Date de création",
        edit: 'Éditer',
        delete: 'Supprimer',
        addNewLocation: 'Ajouter un nouvel emplacement',
        locations: 'Emplacements',
        close: 'Fermer',
        submit: 'soumettre',
        repeatPassword: 'Répéter le mot de passe',

        login: {
            email: 'Email',
            password: 'Mot de passe',
            loginBtn: 'Se connecter',
            type: 'Centre de formation'
        },
        home: {
            active: 'En cours',
            ended: 'Éffectué',
            completed: 'Terminé',
            internshipOngoing: 'Stages en cours',
            search: 'Rechercher',
            addNewClass: 'Créer un nouveau stage',
            viewParticipants: 'Voir les inscrits',
            completeInternship: 'Terminer le stage',
            completedInternships: 'Stages terminés',
            internshipToEnd: 'Stage à terminer',
            confirmCompletion: 'Terminer maintenant',
            studentMovementConfirmation: 'Êtes-vous sure de modifier le stage pour cet élève ?',
            generateCertificate: 'Générer les attestations',
            generateCertificateConfirm: 'Voulez-vous générer l\'attestation pour cet élève ?',
            location: 'Adresse',
            customerMovementSuccess: 'Le stagiaire à été envoyé vers le stage sélectionner',
            participants: 'Participants',
            createInternship: {
                startingDate: 'Date de début',
                endingDate: 'Date de fin',
                startingTime: 'Heure de début',
                endingTime: 'Heure de fin',
                selectBAFM: 'Sélectionner le BAFM',
                selectPsychologist: 'Sélectionner le psychologue',
                selectLocation: 'Sélectionner l\'adresse',
                maxParticipants: 'Nombre maximum de participant (20)',
                price: 'Prix visible par le client',
            }
        },

        trainer: {
            trainer: 'trainer',
            addNewTrainer: 'Ajouter un nouveau formateur',
            viewSchedule: 'Voir le calendrier',
            editTrainer: 'Modifier le formateur',
            blockTrainer: 'Entraîneur de blocs',
            unblockTrainer: 'Débloquer l\'entraîneur',
            firstName: 'Prénom',
            lastName: 'Nom de famille',
            gender: 'Le genre',
            telephoneNo: 'Numéro de téléphone',
            address: 'Adresse',
            emailVerified: 'Email verifié',
            actions: 'Actions',
        },

        cancel: 'Annuler',
        clear: 'Éffacer',
        create: 'Créer',
        yes: 'Oui',
        no: 'Non',
        today: 'Aujourd\'hui',
        day: 'Jours',
        week: 'Semaine',
        month: 'Mois'
    }
};

export const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages
});